import { render, staticRenderFns } from "./CallList.vue?vue&type=template&id=0ef5be20&scoped=true&"
import script from "./CallList.vue?vue&type=script&lang=ts&"
export * from "./CallList.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./CallList.vue?vue&type=style&index=0&id=0ef5be20&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0ef5be20",
  null
  ,true
)

export default component.exports